/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Carousel, Accordion, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import moment from 'moment';
import { cloneDeep, concat, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkArray, createOptions, customStylesWhiteBordered } from '../../../../Components/helper';
import { costingAndPurchasing, otherPackage, sampleModule, submitEmail, technicalPackage } from './CommonSubmitModule';
import '../../SubmitDownload/SubmitDownload.css';
import { fetchProductDetails, fetchTrafficLights } from '../../Bom/store/BOMConfig.action';
import {
  bulkSubmitDownload,
  getColourWays,
  getDesignDetail,
  getLegLength,
  getMainSamples as getMainSamplesAction,
  getOrderSamples,
  getSampleTraking,
  getSampleTypeGroupsByProduct,
  getSizes,
  getSupportingDesignDetails,
} from '../../store/DevelopmentOrder.action';
import {
  getBOMSUDocuments,
  getBulkFilteredPOs,
  getMeasurementDocuments,
  getPoDocuments,
} from '../../SubmitDownload/Store/Submit.action';
import { getAllActiveDocuments } from '../../Measurment/Store/Measurement.action';
import { fetchSupplierComponents } from '../../../Supplier/store/Supplier.action';
import { getAllUnitDetails, getOtherSamplesDetails } from '../../../SystemMasters/Store/SystemMasters.action';
import { fetchColorListLibrary } from '../../../Library/ColorLibary/store/ColorLibrary.action';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { getCreatedByUser } from '../../../Dashboard/TodoList/PurchaseOrder/store/Purchase.action';
import Loader from '../../../../Components/Utility/Loader/Loader';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import { fetchDevorderSupplier } from '../../PurchaseOrder/Store/PurchaseOrder.action';

const SAMPLE_TYPE_OTHER = 'other';
const SAMPLE_TYPE_MAIN = 'main';
const INTERNAL_SUPPLIER_ID = 'internal';
const INTERNAL_SUPPLIER_OPTION = { _id: INTERNAL_SUPPLIER_ID, value: INTERNAL_SUPPLIER_ID, label: 'Internal', name: 'Internal', email: '' };

function SubmitPopupModal({ mainState, toggle, listState, setMainState }) {
  const { show, selectedType, commonSupplierList, productData } = mainState;
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    index: 0,
    showRequestSample: false,
    showComposeEmail: false,
    changed: true,
    selectedData: {},
    supplierOptions: commonSupplierList,
    bomDocumentOptions: [],
    colourDocumentOptions: [],
    pomDocumentOptions: [],
    otherDocumentOptions: [],
    poDocumentOptions: [],
    selectedSupplier: null,
    poOptions: [],
    sampleOptions: [],
    submitData: [],
    factoryOptions: [],
    mainSampleList: [],
    unitOptions: [],
    colourWayOpt: [],
    sizeOpt: [],
    lengthOpt: [],
    userList: [],
    toErr: false,
    bccErr: false,
    ccErr: false,
    spin: false,
    gradingGroups: [],
    specificationGradGroup: [],
    selectedgradingOptions: [],
    cadGradGroup: [],
    colourWayOptions: [],
    designDocumentOptions: [],
    sampleTypeGroupOpts: [],
    allOrderSamples: {},
  });
  const [lengthEnabled, setLengthEnabled] = useState(true);
  const gradingRowIdRef = useRef(0);
  const nextGradingRowId = () => {
    gradingRowIdRef.current += 1;
    return gradingRowIdRef.current;
  };
  const stateValueset = (val, value) => {
    setState((prev) => ({
      ...prev,
      [val]: value,
    }));
  };
  const dispatch = useDispatch();
  const reducers = useSelector((redState) => redState);
  const { Measuremets, UserDetails, BOMConfigDetails, ColorLibraryDetails, SubmitDownloadReducer } = reducers;
  const { mainSamples, sampleLength, sampleColourWays, sampleSizes, sampleTrakingDates, sampleTypeGroupsByProduct } = Measuremets;
  const {
    SystemMastersDetails: { otherSamplesList, unitList },
  } = reducers;
  const { ColorWaysLibList } = ColorLibraryDetails;
  const { productDetails } = BOMConfigDetails;
  const { userInfo } = UserDetails;
  const { BulkFilteredPOs = [] } = SubmitDownloadReducer || {};
  const { selectedIds } = listState;
  const {
    index,
    showComposeEmail,
    showRequestSample,
    changed,
    supplierOptions,
    selectedSupplier,
    submitData,
    spin,
    sampleOptions,
    poOptions,
    bomDocumentOptions,
    colourDocumentOptions,
    pomDocumentOptions,
    otherDocumentOptions,
    poDocumentOptions,
    gradingGroups,
    designDocumentOptions,
  } = state;

  const getMainSamples = async () => {
    await dispatch(getSampleTraking());
    await dispatch(getMainSamplesAction({ loggedInUserId: userInfo.userId, isActive: true }));
  };
  const getOtherSamples = async () => {
    await dispatch(
      getOtherSamplesDetails({
        loggedInUserId: userInfo.userId,
        isActive: true,
      }),
    );
  };
  const getUnitMaster = async () => {
    await dispatch(
      getAllUnitDetails({
        loggedInUserId: userInfo.userId,
        isActive: true,
      }),
    );
  };

  const createOption = (array, type) => {
    let list = [];
    if (array?.length) {
      list = array.map((item) => {
        const obj = {
          label: item.name || item,
          value: item._id || item,
        };
        if (type) {
          obj.typeOfSampleType = type;
        }
        return obj;
      });
    }
    return list;
  };

  const setMainSampleListOpt = (optionList) => {
    const list = [...optionList];
    stateValueset('mainSampleList', list);
  };

  const getFilteredPOsForCurrentDevOrder = (currentDevOrderId) => {
    if (!BulkFilteredPOs || !Array.isArray(BulkFilteredPOs) || !currentDevOrderId) {
      return [];
    }

    // Filter POs that belong to the current development order
    const filteredPOs = BulkFilteredPOs.filter((po) => {
      // Check if PO has orderDetails array and find matching devOrderId
      if (po.orderDetails && Array.isArray(po.orderDetails)) {
        return po.orderDetails.some((detail) => detail.productNumber && detail.productNumber.toString() === currentDevOrderId.toString());
      }
      return false;
    });

    // Convert to options format
    return filteredPOs.map((po) => ({
      label: po.purchaseOrderNumber || po.poOrderNo || `PO-${po._id}`,
      value: po._id,
      _id: po._id,
    }));
  };

  const getSupplierFactories = async (supplierId) => {
    const params = {
      pageSize: 20,
      pageIndex: 1,
      supplierId,
    };
    const res = await dispatch(fetchSupplierComponents(params));
    stateValueset('factoryOptions', res.doc);
  };

  const loadBulkFilteredPOs = async (supplierOverride = null) => {
    const supplier = supplierOverride || selectedSupplier;
    if (!supplier?._id || !selectedIds?.length) {
      return;
    }

    const selectedColourwayIds = state?.submitData?.[index]?.selectedColourway?.map((cw) => cw?._id || cw?.value) || [];

    const params = {
      devOrderIds: selectedIds,
      supplierIds: [supplier._id],
      ...(selectedColourwayIds.length > 0 && { colourwayIds: selectedColourwayIds }),
    };

    try {
      await dispatch(getBulkFilteredPOs(params));
    } catch (error) {
      // Error handling is done in the action
    }
  };
  const initialExicution = async (id) => {
    const devOrderId = id;
    await Promise.all([
      dispatch(getColourWays({ devOrderId })),
      dispatch(getSizes({ devOrderId })),
      dispatch(fetchDevorderSupplier({ devOrderId, allDetails: true })),
      dispatch(getLegLength({ devOrderId })),
      dispatch(fetchProductDetails(devOrderId)),
      dispatch(fetchTrafficLights(devOrderId)),
      dispatch(getDesignDetail(devOrderId)),
      dispatch(fetchColorListLibrary({ loggedInUserId: userInfo.userId })),
    ]);
    const measurObj = {
      id: devOrderId,
      obj: {
        isDropDown: true,
      },
    };

    const pomRes = await dispatch(getMeasurementDocuments(measurObj));
    const otherRes = await dispatch(getAllActiveDocuments(devOrderId)); // after new change
    const poRes = await dispatch(getPoDocuments(measurObj));
    const bomRes = await dispatch(getBOMSUDocuments(measurObj));
    const designRes = await dispatch(getSupportingDesignDetails(devOrderId));
    let BOMDocuments = [];
    let ColourDocuments = [];
    let POMDocuments = [];
    let PODocuments = [];
    let OTHERDocuments = [];
    let designSupportDocs = [];
    if (bomRes && bomRes.length > 0) {
      const modifiedArray = bomRes.map((dat) => {
        const mDate = moment(dat.createdAt).format('DD-MMMM-YYYY, HH:mm');
        dat.label = `${dat.fileName} ${mDate}`;
        dat.value = dat?._id;
        return dat;
      });

      BOMDocuments = modifiedArray ? modifiedArray.filter((i) => !i.docType || i.docType === 'Quality') : [];

      ColourDocuments = modifiedArray ? modifiedArray.filter((i) => i.docType === 'Colour') : [];
    }
    if (pomRes && pomRes.length > 0) {
      POMDocuments = createOptions(pomRes, 'fileName', '_id');
    }
    if (otherRes?.data?.length > 0) {
      OTHERDocuments = createOptions(otherRes?.data, 'documentTitle', '_id');
    }
    if (poRes && poRes.length > 0) {
      PODocuments = createOptions(poRes, 'fileName', '_id');
    }
    if (designRes?.data && designRes?.data?.length > 0) {
      designSupportDocs = createOptions(designRes.data, 'documentName', '_id');
    }
    setState((prev) => ({
      ...prev,
      loader: false,
      bomDocumentOptions: BOMDocuments,
      colourDocumentOptions: ColourDocuments,
      poDocumentOptions: PODocuments,
      otherDocumentOptions: OTHERDocuments,
      pomDocumentOptions: POMDocuments,
      designDocumentOptions: designSupportDocs,
    }));
  };
  const init = async () => {
    const devOrderId = selectedIds[index];

    await loadBulkFilteredPOs();

    let sampleOptionsforLabel = [];
    const res1 = await dispatch(getOrderSamples(devOrderId));
    if (res1?.code === 200) {
      const samplesForProduct = res1?.data || [];
      setState((prev) => ({
        ...prev,
        allOrderSamples: { ...prev.allOrderSamples, [devOrderId]: samplesForProduct },
      }));
      const sampleOptionsOfSupp = res1?.data?.filter((sam) => sam?.supplier === selectedSupplier?._id);
      sampleOptionsforLabel = createOptions(sampleOptionsOfSupp, 'sampleNumber', '_id');
      sampleOptionsforLabel.forEach((opt) => {
        const sampleDate = moment(opt.createdAt).format('DD-MMMM-YYYY, HH:mm');
        const newLabel = `${opt.label} ${sampleDate}`;
        opt.label = newLabel;
      });
    }

    const userList = await dispatch(
      getCreatedByUser({
        CompanyUsers: true,
        supplierId: selectedSupplier?._id,
      }),
    );
    let userList1 = [];
    if (userList) {
      userList1 = userList.map((val) => ({
        id: val.email,
        name: `${val.firstName} ${val.lastName}`,
        display: `${val.email}, `,
        label: val.email,
      }));
    }
    setState((prev) => ({
      ...prev,
      sampleOptions: sampleOptionsforLabel,
      userList: userList1,
    }));
  };
  useEffect(() => {
    getMainSamples();
    getOtherSamples();
    getUnitMaster();
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (user?.lengthVisible !== undefined && user?.lengthVisible !== null) {
      setLengthEnabled(user?.lengthVisible);
    }
  }, []);

  useEffect(() => {
    if (ColorWaysLibList?.length > 0) {
      const arr = [];
      productDetails?.colourLibraries?.forEach((item) => {
        const colour = ColorWaysLibList?.filter((test) => test?._id === item)?.map((k) => ({
          label: k?.name,
          name: k?.name,
          value: k?._id,
          _id: k?._id,
        }))[0];
        if (colour) {
          arr.push(colour);
        }
      });
      setState((prev) => ({
        ...prev,
        colourWayOptions: arr,
      }));
    }
  }, [ColorWaysLibList, productDetails]);

  useEffect(() => {
    const len = commonSupplierList?.length;
    const data = [];
    selectedIds.forEach((da) => {
      data.push({
        devOrderId: da,
        selectedModules: [],
        supplier: len === 1 ? commonSupplierList[0]?._id : '',
        isTechPackCombined: true,
        selectedColourway: [],
        sampleRequest: {
          requestType: 'request',
          sampleTypeGroupId: null,
          isNewSample: true,
          typeOfSampleType: 'main',
          sampleType: null,
          supplier: '',
          parentId: null,
          revisionRootId: null,
          versionNumber: null,
          colourwayGroup: null,
          gradingGroupData: [
            {
              id: nextGradingRowId(),
              gradingGroup: null,
              size: [],
              len: null,
              uom: null,
              quantity: null,
              sizeRanges: [],
            },
          ],
        },
      });
    });
    setState((prev) => ({
      ...prev,
      submitData: data,
      selectedSupplier: len === 1 ? commonSupplierList[0] : null,
    }));
  }, [selectedIds, commonSupplierList]);

  useEffect(() => {
    const colourWayOpt = createOption([...sampleColourWays]);
    const sizeOpt = createOption([...sampleSizes]);
    const lengthOpt = createOption([...sampleLength]);
    setState((prev) => ({
      ...prev,
      colourWayOpt,
      sizeOpt,
      lengthOpt,
    }));
  }, [sampleColourWays, sampleLength, sampleSizes]);

  useEffect(() => {
    const id = selectedIds[index];
    initialExicution(id);
    init();
  }, [changed]);

  // Initial load when modal opens and supplier is available
  useEffect(() => {
    if (show && selectedSupplier && selectedIds?.length > 0) {
      const id = selectedIds[index];
      initialExicution(id);
      init();
    }
  }, [show, selectedSupplier, selectedIds]);

  useEffect(() => {
    if (show && selectedIds?.length > 0 && commonSupplierList?.length === 1) {
      const supplier = commonSupplierList[0];
      if (supplier) {
        loadBulkFilteredPOs(supplier);
      }
    }
  }, [show, selectedIds, commonSupplierList]);

  useEffect(() => {
    if (selectedSupplier && submitData?.length) {
      const cloneData = submitData;
      const toMail = selectedSupplier?.email ? `${selectedSupplier?.email}, ` : '';
      if (cloneData[index]) {
        cloneData[index].to = toMail;
      }
      cloneData.map((da) => {
        da.to = toMail;
        da.isCommonMessage = false;
        return da;
      });
      setState((prev) => ({
        ...prev,
        submitData: cloneData,
      }));
      init();
    }
  }, [selectedSupplier]);

  useEffect(() => {
    if (BulkFilteredPOs && BulkFilteredPOs.length > 0 && selectedIds?.length > 0 && index >= 0) {
      const currentDevOrderId = selectedIds[index];
      const filteredPOs = getFilteredPOsForCurrentDevOrder(currentDevOrderId);
      setState((prev) => ({
        ...prev,
        poOptions: filteredPOs,
      }));
    }
  }, [BulkFilteredPOs, index, selectedIds]);

  useEffect(() => {
    if (selectedSupplier?._id && submitData?.[index]?.selectedColourway) {
      loadBulkFilteredPOs();
    }
  }, [submitData?.[index]?.selectedColourway, selectedSupplier]);

  useEffect(() => {
    if (submitData[index]?.sampleRequest?.supplier) {
      getSupplierFactories(submitData[index]?.sampleRequest?.supplier);
    }
  }, [submitData[index]?.sampleRequest?.supplier]);

  useEffect(() => {
    if (checkArray(unitList)) {
      const list = createOption([...unitList]);
      stateValueset('unitOptions', list);
    }

    const currentTypeOfSampleType = submitData[index]?.sampleRequest?.typeOfSampleType;
    if (currentTypeOfSampleType === SAMPLE_TYPE_OTHER && checkArray(otherSamplesList)) {
      setMainSampleListOpt(createOption(otherSamplesList, SAMPLE_TYPE_OTHER));
    } else if (checkArray(mainSamples)) {
      setMainSampleListOpt(createOption(mainSamples, SAMPLE_TYPE_MAIN));
    }
  }, [mainSamples, unitList, otherSamplesList, submitData]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      gradingGroups: productDetails?.gradingGroups,
    }));
  }, [productDetails]);

  useEffect(() => {
    if (!productDetails || Object.keys(productDetails).length === 0) return;
    const attrs = {
      brandId: productDetails?.brandId?._id || productDetails?.brandId || productDetails?.brand?.[0]?._id || productDetails?.brand?._id,
      subBrandId: productDetails?.subBrandId?._id || productDetails?.subBrandId || productDetails?.subBrand?.[0]?._id || productDetails?.subBrand?._id,
      productType: productDetails?.supplierType?._id || productDetails?.supplierType || productDetails?.productType?._id || productDetails?.productType,
      category1: productDetails?.catOneId?._id || productDetails?.catOneId,
      category2: productDetails?.catTwoId?._id || productDetails?.catTwoId,
      category3: productDetails?.catThreeId?._id || productDetails?.catThreeId,
      category4: productDetails?.catFourId?._id || productDetails?.catFourId,
      licensorId: productDetails?.licensorId?._id || productDetails?.licensorId,
      licenseId: productDetails?.licenseId?._id || productDetails?.licenseId,
      likenessId: productDetails?.likenessId?._id || productDetails?.likenessId,
      isLicensedProduct: productDetails?.isLicensedProduct ?? false,
    };
    const filtered = Object.fromEntries(Object.entries(attrs).filter(([, value]) => value != null));
    if (Object.keys(filtered).length > 0) {
      dispatch(getSampleTypeGroupsByProduct(filtered));
    }
  }, [productDetails]);

  const resolveNextSampleContext = (group, allSamples) => {
    const empty = { sampleType: null, parentId: null, revisionRootId: null, versionNumber: null, supplier: null };
    const sequence = group?.sampleTypeAutomation;
    if (!sequence?.length) return empty;

    const isAutomated = sequence[0]?.configuration?.length > 0;

    const samplesInGroup = (allSamples || []).filter((s) => String(s.sampleTypeGroupId) === String(group._id));

    let nextTypeIdx = 0;
    if (samplesInGroup.length > 0) {
      const lastSampleAny = samplesInGroup.reduce((latest, current) =>
        new Date(latest.createdAt) > new Date(current.createdAt) ? latest : current,
      );
      const lastSampleTypeId = String(lastSampleAny.sampleTypeObj?._id || lastSampleAny.sampleType?._id || lastSampleAny.sampleType);
      const lastTypeIdx = sequence.findIndex((s) => String(s.sampleType?._id) === lastSampleTypeId);
      if (lastTypeIdx >= 0) nextTypeIdx = lastTypeIdx;
    }

    const nextTypeId = sequence[nextTypeIdx]?.sampleType?._id || null;

    if (!isAutomated || !nextTypeId) {
      return { ...empty, sampleType: nextTypeId };
    }

    const typeOf = (s) => String(s?.sampleTypeObj?._id || s?.sampleType?._id || s?.sampleType);
    const sampleById = new Map(samplesInGroup.map((s) => [String(s._id), s]));

    const sameTypeSamples = samplesInGroup.filter((s) => typeOf(s) === String(nextTypeId));
    const pureChainCandidates = sameTypeSamples.filter((s) => {
      const rootId = s.revisionRootId ? String(s.revisionRootId) : String(s._id);
      const root = sampleById.get(rootId) || s;
      return typeOf(root) === String(nextTypeId);
    });

    if (pureChainCandidates.length === 0) {
      return { ...empty, sampleType: nextTypeId };
    }

    const lastSame = pureChainCandidates.reduce((latest, current) =>
      new Date(latest.createdAt) > new Date(current.createdAt) ? latest : current,
    );

    return {
      sampleType: nextTypeId,
      parentId: lastSame._id,
      revisionRootId: lastSame.revisionRootId || lastSame._id,
      versionNumber: (lastSame.versionNumber || 1) + 1,
      supplier: lastSame.supplier?._id || lastSame.supplier || null,
    };
  };

  useEffect(() => {
    const groups = sampleTypeGroupsByProduct || [];
    const opts = [...groups, { _id: SAMPLE_TYPE_OTHER, sampleGroupName: 'Other Sample' }];
    setState((prev) => ({ ...prev, sampleTypeGroupOpts: opts }));
  }, [sampleTypeGroupsByProduct]);

  useEffect(() => {
    const map = state.allOrderSamples;
    if (!map || Object.keys(map).length === 0) return;
    setState((prev) => {
      const cloneData = cloneDeep(prev.submitData);
      cloneData.forEach((item) => {
        if (!item.sampleRequest?.sampleTypeGroupId) return;
        const group = prev.sampleTypeGroupOpts?.find((opt) => opt._id === item.sampleRequest.sampleTypeGroupId);
        if (!group) return;
        const productSamples = prev.allOrderSamples?.[item.devOrderId] || [];
        if (productSamples.length === 0) return;
        const ctx = resolveNextSampleContext(group, productSamples);
        if (!item.sampleRequest.sampleType && ctx.sampleType) item.sampleRequest.sampleType = ctx.sampleType;
        if (ctx.parentId) item.sampleRequest.parentId = ctx.parentId;
        if (ctx.revisionRootId) item.sampleRequest.revisionRootId = ctx.revisionRootId;
        if (ctx.versionNumber) item.sampleRequest.versionNumber = ctx.versionNumber;
        if (ctx.supplier) item.sampleRequest.supplier = ctx.supplier;
      });
      return { ...prev, submitData: cloneData };
    });
  }, [state.allOrderSamples]);

  const validationFun = (ind) => {
    const foundData = ind ? submitData[ind]?.selectedModules : submitData[index]?.selectedModules;
    const foundData1 = ind ? submitData[ind] : submitData[index];
    const obj = [
      {
        findData: 'otherSpecificationDoc',
        document: 'selectedotherDocumentOptions',
      },
      { findData: 'document', document: 'selectedpomDocumentOptions' },
      { findData: 'colourDocument', document: 'selectedcolourDocumentOptions' },
      { findData: 'bomDocument', document: 'selectedbomDocumentOptions' },
      { findData: 'poDocuments', document: 'selectedpoDocumentOptions' },
      { findData: 'po', document: 'pos' },
      { findData: 'sample', document: 'sampleType' },
    ];

    let count = 0;
    obj.forEach((dat) => {
      if (foundData?.indexOf(dat.findData) > -1) {
        if (!foundData1[dat.document]?.length) {
          count++;
        }
      }
    });
    if (!foundData1?.supplier) {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_POPUP_MODAL.SELECT_SUPLIER'), 'danger');
      return false;
    }
    if (count > 0) {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_POPUP_MODAL.SELECT_AT_LEAST_ONE_DOCUMENT'), 'danger');
      return false;
    }
    return true;
  };

  const handleSelectCorousel = (selectedIndex, e) => {
    const validation = validationFun();
    const sampleValidation1 = sampleValidation();
    if (validation && sampleValidation1) {
      setState((prev) => ({
        ...prev,
        index: selectedIndex,
        changed: !prev.changed,
        colourWayOptions: [],
      }));
    }
  };

  const findNameOfProduct = (id) => {
    const name = productData.find((dat) => dat._id === id);
    return name ? name.number : '';
  };

  const renderTooltipOpenClose = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!showRequestSample ? 'Close' : 'Open'}
    </Tooltip>
  );
  const renderTooltipOpenCloseEmail = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!showComposeEmail ? 'Close' : 'Open'}
    </Tooltip>
  );

  const sampleValidation = () => {
    const foundData = submitData[index]?.sampleRequest;
    const foundData1 = cloneDeep(submitData);
    let count = 0;
    if (submitData[index]?.isSampleRequested) {
      const errObj = {
        supplier: false,
        sampleType: false,
        gradingGroupData: false,
      };
      if (!foundData?.supplier) {
        errObj.supplier = true;
        count += 1;
      }
      if (!foundData?.sampleType) {
        errObj.sampleType = true;
        count += 1;
      }
      if (!foundData?.gradingGroupData?.length) {
        errObj.gradingGroupData = true;
        count += 1;
      }
      foundData1[index].sampleErr = errObj;
      stateValueset('submitData', foundData1);
      if (count > 0) {
        return false;
      }
      return true;
    }
    return true;
  };

  const handleSelectChange = (val, key, sample) => {
    const cloneData = cloneDeep(submitData);
    if (!cloneData[index]) {
      cloneData[index] = {};
    }
    if (key === 'selectedColourway') {
      cloneData[index].selectedColourway = val;
    } else if (key === 'selectedSupplier') {
      stateValueset(key, val);
      cloneData.map((da) => {
        da.supplier = val?._id;
        /* Sample options are supplier-scoped, so a selection made under the previous supplier is no
           longer valid — reset the Technical Package sample field, the sample module flag, and the
           Request Sample sub-object so no stale value survives a supplier change. */
        da.sampleType = [];
        if (Array.isArray(da.selectedModules)) {
          da.selectedModules = da.selectedModules.filter((module) => module !== 'sample');
        }
        if (da.sampleRequest) {
          da.sampleRequest.sampleTypeGroupId = null;
          da.sampleRequest.typeOfSampleType = 'main';
          da.sampleRequest.sampleType = null;
          da.sampleRequest.supplier = '';
          da.sampleRequest.parentId = null;
          da.sampleRequest.revisionRootId = null;
          da.sampleRequest.versionNumber = null;
        }
        return da;
      });
    } else if (sample) {
      if (key === 'sampleTypeGroupId') {
        const isOther = val?._id === SAMPLE_TYPE_OTHER;
        cloneData[index].sampleRequest.sampleTypeGroupId = isOther ? null : val?._id || null;
        cloneData[index].sampleRequest.typeOfSampleType = isOther ? SAMPLE_TYPE_OTHER : SAMPLE_TYPE_MAIN;
        cloneData[index].sampleRequest.sampleType = null;

        if (!isOther) {
          const productSamples = state.allOrderSamples?.[cloneData[index].devOrderId] || [];
          const ctx = resolveNextSampleContext(val, productSamples);
          cloneData[index].sampleRequest.sampleType = ctx.sampleType;
          cloneData[index].sampleRequest.parentId = ctx.parentId;
          cloneData[index].sampleRequest.revisionRootId = ctx.revisionRootId;
          cloneData[index].sampleRequest.versionNumber = ctx.versionNumber;
          if (ctx.supplier) cloneData[index].sampleRequest.supplier = ctx.supplier;
        } else {
          cloneData[index].sampleRequest.parentId = null;
          cloneData[index].sampleRequest.revisionRootId = null;
          cloneData[index].sampleRequest.versionNumber = null;
        }

        setState((prev) => ({ ...prev, submitData: cloneData }));
        return;
      } 
        cloneData[index].sampleRequest[key] = val?._id || val?.value || val;
        if (key === 'supplier') {
          cloneData[index].sampleRequest.factory = '';
        }
        if (key === 'sampleType') {
          cloneData[index].sampleRequest.typeOfSampleType = val?.typeOfSampleType;
        }
      
    } else {
      const fieldArr = [
        'pos',
        'sampleType',
        'specificationGradGroup',
        'selectedgradingOptions',
        'selectedpoDocumentOptions',
        'selectedbomDocumentOptions',
        'selectedcolourDocumentOptions',
        'selectedotherDocumentOptions',
        'selectedpomDocumentOptions',
        'selecteddesignDocumentOptions',
        'isTechPackCombined',
        'isSampleRequested',
        'showRequestSample',
        'cadGradGroup',
      ];
      if (key === 'message' && !cloneData[0]?.isCommonMessage) {
        fieldArr.push('message');
      }
      if (fieldArr.includes(key)) {
        cloneData[index][key] = val;
      } else {
        cloneData.map((da) => {
          da[key] = val;
          return da;
        });
      }
    }
    stateValueset('submitData', cloneData);
  };

  const valueChange = (value, array, selectedModules1) => {
    if (value) {
      array.forEach((model) => {
        if (selectedModules1.indexOf(model) === -1) {
          selectedModules1.push(model);
        }
      });
    } else {
      array.forEach((model) => selectedModules1.splice(selectedModules1.indexOf(model), 1));
    }
  };

  function handleSelectAll(_section, value, givenArray) {
    const cloneData = cloneDeep(submitData);
    if (!cloneData[index]) {
      cloneData[index] = {};
    }
    const selectedModules1 = cloneData[index]?.selectedModules ? cloneData[index]?.selectedModules : [];
    valueChange(value, givenArray, selectedModules1);
    cloneData[index].selectedModules = selectedModules1;
    if (selectedModules1.includes('po') && poOptions?.length === 1) {
      cloneData[index].pos = [poOptions[0]?.value];
    }
    if (selectedModules1.includes('measurement') && gradingGroups?.length === 1) {
      cloneData[index].specificationGradGroup = [gradingGroups[0]?.value];
    }
    if (selectedModules1.includes('pomImgs') && gradingGroups?.length === 1) {
      cloneData[index].selectedgradingOptions = [gradingGroups[0]?.value];
    }
    if (selectedModules1.includes('sample') && sampleOptions?.length === 1) {
      cloneData[index].sampleType = [sampleOptions[0]?.value];
    }
    if (selectedModules1.includes('bomDocument') && bomDocumentOptions?.length === 1) {
      cloneData[index].selectedbomDocumentOptions = [bomDocumentOptions[0]?.value];
    }
    if (selectedModules1.includes('colourDocument') && colourDocumentOptions?.length === 1) {
      cloneData[index].selectedcolourDocumentOptions = [colourDocumentOptions[0]?.value];
    }
    if (selectedModules1.includes('otherSpecificationDoc') && otherDocumentOptions?.length === 1) {
      cloneData[index].selectedotherDocumentOptions = [otherDocumentOptions[0]?.value];
    }
    if (selectedModules1.includes('poDocuments') && poDocumentOptions?.length === 1) {
      cloneData[index].selectedpoDocumentOptions = [poDocumentOptions[0]?.value];
    }
    if (selectedModules1.includes('pomDocument') && pomDocumentOptions?.length === 1) {
      cloneData[index].selectedpomDocumentOptions = [pomDocumentOptions[0]?.value];
    }
    if (selectedModules1.includes('designDocument') && designDocumentOptions.length === 1) {
      cloneData[index].selecteddesignDocumentOptions = [designDocumentOptions[0]?.value];
    }
    cloneData.map((cl) => {
      cl.selectedModules = selectedModules1;
      return cl;
    });
    stateValueset('submitData', cloneData);
  }

  const checkIsChecked = (field, single, checkedValue) => {
    const cloneData = cloneDeep(submitData);
    const selectedModules1 = cloneData[index]?.selectedModules ? cloneData[index]?.selectedModules : [];
    if (checkedValue) {
      const data = cloneData[index];
      return data?.isTechPackCombined;
    }
    if (single) {
      return selectedModules1?.indexOf(single) > -1;
    }
    let count = 0;
    field.forEach((sel) => {
      if (selectedModules1.includes(sel)) {
        count++;
      }
    });
    return count === field.length;
  };

  const getSelectedSupplier = () => {
    const findSup = submitData[index];
    if (findSup?.supplier === INTERNAL_SUPPLIER_ID) {
      return INTERNAL_SUPPLIER_OPTION;
    }
    const ck = supplierOptions?.find((op) => op._id === findSup?.supplier);
    return ck || null;
  };

  function handleSelect(field, options) {
    const cloneData = [...submitData];
    const selectedModules1 = cloneData[index]?.selectedModules ? cloneData[index]?.selectedModules : [];
    if (selectedModules1.indexOf(field) > -1) {
      selectedModules1.splice(selectedModules1.indexOf(field), 1);
    } else {
      selectedModules1.push(field);
    }
    const fieldArr = ['po', 'sample', 'colourDocument', 'bomDocument', 'document', 'otherSpecificationDoc', 'poDocuments', 'designDocument'];
    if (field === 'po' && poOptions?.length === 1) {
      cloneData[index].pos = [poOptions[0]?.value];
    }
    if (field === 'measurement' && gradingGroups?.length === 1) {
      cloneData[index].specificationGradGroup = [gradingGroups[0]?.value];
    }
    if (field === 'pomImgs' && gradingGroups?.length === 1) {
      cloneData[index].selectedgradingOptions = [gradingGroups[0]?.value];
    }
    if (field === 'sample' && sampleOptions?.length === 1) {
      cloneData[index].sampleType = [sampleOptions[0]?.value];
    }
    if (state[options]?.length === 1) {
      cloneData[index][`selected${options}`] = [state[options][0]?.value];
    }
    if (fieldArr?.includes(field)) {
      cloneData[index].selectedModules = selectedModules1;
    } else {
      cloneData.forEach((cl) => {
        cl.selectedModules = [...cl.selectedModules, ...selectedModules1];
        cl.selectedModules = cl.selectedModules.filter((item, index) => cl.selectedModules.indexOf(item) === index);
        return cl;
      });
    }
    stateValueset('submitData', cloneData);
  }
  const multiselectValues = (first, second) => {
    const options = state[first];
    const cloneData = cloneDeep(submitData);
    let selected = [];
    if (cloneData[index]) {
      if (cloneData[index][second]) {
        selected = cloneData[index][second] ? cloneData[index][second] : [];
      }
    }
    return options?.filter((val) => !isEmpty(options) && selected?.includes(val?._id ? val?._id : val?.value));
  };
  const getValue = (field) => {
    return submitData[index] ? submitData[index][field] : '';
  };

  const buildSizeRanges = (gradingGroupVal, details) => {
    if (!gradingGroupVal || !details?.gradingGroups) return [];
    const matched = details.gradingGroups.find((g) => g.value === gradingGroupVal.value);
    if (!matched) return [];
    return (matched.sizeRanges || []).filter((sr) => details.sizeRanges?.includes(sr.name)).map((sr) => ({ ...sr, label: sr.name, value: sr.name }));
  };

  const sortByOptionOrder = (selected, options) => {
    if (!Array.isArray(selected) || !Array.isArray(options) || options.length === 0) return selected || [];
    const order = options.map((o) => o?.value);
    return [...selected].sort((left, right) => {
      const leftIdx = order.indexOf(left?.value);
      const rightIdx = order.indexOf(right?.value);
      return (leftIdx === -1 ? order.length : leftIdx) - (rightIdx === -1 ? order.length : rightIdx);
    });
  };

  const updateGradingGroup = (gradingIdx, field, val) => {
    const cloneData = cloneDeep(submitData);
    const row = cloneData[index].sampleRequest.gradingGroupData[gradingIdx];
    if (field === 'gradingGroup') {
      row.gradingGroup = val;
      row.sizeRanges = buildSizeRanges(val, productDetails);
      row.size = [];
    } else if (field === 'size') {
      row.size = sortByOptionOrder(val, row.sizeRanges);
    } else {
      row[field] = val;
    }
    stateValueset('submitData', cloneData);
  };

  const addNewGradingGroup = () => {
    const cloneData = cloneDeep(submitData);
    cloneData[index].sampleRequest.gradingGroupData.push({
      id: nextGradingRowId(),
      gradingGroup: null,
      size: [],
      len: null,
      uom: null,
      quantity: null,
      sizeRanges: [],
    });
    stateValueset('submitData', cloneData);
  };

  const handleGradingGroupDelete = (gradingIdx) => {
    const cloneData = cloneDeep(submitData);
    if (cloneData[index].sampleRequest.gradingGroupData.length > 1) {
      cloneData[index].sampleRequest.gradingGroupData.splice(gradingIdx, 1);
      stateValueset('submitData', cloneData);
    }
  };

  const expandGradingGroups = (groups) => {
    const expanded = [];
    (groups || []).forEach((group) => {
      const sizes = group.size || [];
      if (!sizes.length) {
        expanded.push({ ...group, size: null });
      } else {
        sizes.forEach((sizeItem) => expanded.push({ ...group, size: sizeItem }));
      }
    });
    return expanded;
  };

  function validateEmail(email) {
    const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
    return re.test(String(email).toLowerCase());
  }

  const submitValidation = (to, cc, bcc) => {
    let ccMailErr = false;
    let showToVaildErr = false;
    let bccMailErr = false;
    let mailArray = to ? to.split(',') : [];
    let ccMailarray = cc ? cc.split(',') : [];
    let bccMailarray = bcc ? bcc.split(',') : [];
    mailArray = mailArray.filter((val) => val !== '' && val !== ' ');
    showToVaildErr = mailArray.length === 0;
    ccMailarray = ccMailarray.filter((val) => val !== '' && val !== ' ');
    bccMailarray = bccMailarray.filter((val) => val !== '' && val !== ' ');
    mailArray = mailArray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        showToVaildErr = true;
      }
      return val;
    });
    ccMailarray = ccMailarray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        ccMailErr = true;
      }
      return val;
    });
    bccMailarray = bccMailarray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        bccMailErr = true;
      }
      return val;
    });

    setState((prev) => ({
      ...prev,
      toErr: showToVaildErr,
      ccErr: ccMailErr,
      bccErr: bccMailErr,
    }));
    if (!showToVaildErr && !ccMailErr && !bccMailErr) {
      return {
        mailArray,
        ccMailarray,
        bccMailarray,
      };
    }
    return false;
  };

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const getTpAndSelectedVal = (selectedModules, tpArray, isTechCombined) => {
    let tpArray1 = [];
    let selectedModules1 = [];
    if (isTechCombined) {
      tpArray1 = tpArray?.filter((val) => selectedModules?.indexOf(val) > -1);
      if (tpArray1?.length > 0) tpArray1.unshift('dev-order');
      selectedModules1 = selectedModules?.filter((val) => tpArray?.indexOf(val) === -1);
    } else {
      selectedModules1 = selectedModules;
    }

    return { tpArray1, selectedModules1 };
  };

  const tpArray = ['design-details', 'bom', 'measurement', 'care', 'testing', 'sample'];
  const handleSubmit = async () => {
    let selectedModuleserr = 0;
    const sendArray = [];
    const data = submitData[0];
    const { to, cc, bcc, isCommonMessage } = data;

    if (!data.supplier) {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_POPUP_MODAL.SELECT_SUPLIER_FIRST'), 'danger');
      return;
    }
    if (data?.isSampleRequested) {
      const sampleValidation1 = sampleValidation();
      if (sampleValidation1) {
        setState((prev) => ({
          ...prev,
          index: 0,
          changed: !prev.changed,
        }));
      } else {
        return;
      }
    }
    const submitObj = submitValidation(to, cc, bcc);
    const isInternal = data.supplier === INTERNAL_SUPPLIER_ID;
    /* Internal has no supplier email and a download has no compose UI, so an empty "to" is allowed to
       proceed. A "to" the user did type still runs through submitValidation, so a bad format still blocks. */
    const allowEmptyToForInternal = isInternal && (!to || to.trim() === '');
    const effectiveSubmit = submitObj || (allowEmptyToForInternal ? { mailArray: [], ccMailarray: [], bccMailarray: [] } : false);
    let validNum = 0;

    if (effectiveSubmit) {
      submitData.forEach((inrdata, idx) => {
        const valid = validationFun(idx);
        if (!valid) {
          ++validNum;
        }

        const {
          selectedModules,
          sampleType,
          selecteddesignDocumentOptions,
          selectedbomDocumentOptions,
          selectedcolourDocumentOptions,
          selectedotherDocumentOptions,
          selectedpoDocumentOptions,
          selectedpomDocumentOptions,
          pos,
          isTechPackCombined,
          selectedgradingOptions,
          specificationGradGroup,
          cadGradGroup,
          selectedColourway,
        } = inrdata;
        const { tpArray1, selectedModules1 } = getTpAndSelectedVal(selectedModules, tpArray, isTechPackCombined);
        const obj = {
          ...inrdata,
          requestType: selectedType,
          to: effectiveSubmit.mailArray,
          bcc: effectiveSubmit.bccMailarray,
          cc: effectiveSubmit.ccMailarray,
          isCommonMessage: isCommonMessage || false,
          selectedModules: selectedModules1 || [],
          timeZone,
          bomDocuments: selectedbomDocumentOptions || [],
          colourDocuments: selectedcolourDocumentOptions || [],
          otherDocuments: selectedotherDocumentOptions || [],
          designDocument: selecteddesignDocumentOptions || [],
          poDocuments: selectedpoDocumentOptions || [],
          sampleType: sampleType || [],
          pos: pos || [],
          documents: selectedpomDocumentOptions || [],
          tpArray: tpArray1,
          status: 'Pending',
          specificationGradGroup: specificationGradGroup || [],
          pomImgsGradGroup: selectedgradingOptions || [],
          cadGradGroup: cadGradGroup || [],
          colours: selectedColourway?.map((val) => val?._id) || [],
        };

        const trackingDatesArray = [];
        sampleTrakingDates.forEach((track) => {
          if (track.isActive) {
            const obj = {
              label: `${track.name.trim()} Date`,
              value: data.requestType === 'request' && track.refKey === 'requested' ? null : track.value || null,
              trackingUrl: track.trackingUrl || null,
              sampleId: track?._id,
              key: track.refKey || track.key,
              _id: track?._id,
            };
            trackingDatesArray.push(obj);
          }
        });
        obj.sampleRequest.trackingDates = trackingDatesArray;
        if (inrdata.isSampleRequested) {
          obj.sampleRequest.gradingGroupData = expandGradingGroups(inrdata.sampleRequest.gradingGroupData).map((group) => ({
            gradingGroup: group.gradingGroup?.value ?? null,
            size: group.size?.value ?? null,
            len: group.len?.value ?? null,
            uom: group.uom?.value ?? null,
            quantity: group.quantity ?? null,
          }));
        }
        if (selectedModules && selectedModules?.length === 0) {
          selectedModuleserr++;
        }
        sendArray.push(obj);
      });
      if (selectedModuleserr > 0) {
        toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_POPUP_MODAL.SELECT_MODULE'), 'danger');
        return;
      }
      if (validNum > 0) return;
      stateValueset('spin', true);
      const obj = {
        requests: sendArray,
      };
      const res = await dispatch(bulkSubmitDownload(obj));
      if (res === 200) {
        setMainState((prev) => ({
          ...prev,
          selectedIds: [],
        }));
        toggle();
      }
      stateValueset('spin', false);
    }
  };

  const customValueRenderer = () => {
    const currentData = submitData[index];
    if (!currentData?.selectedColourway || currentData?.selectedColourway?.length === 0) {
      return 'Colourway';
    }
    if (currentData?.selectedColourway?.length === state?.colourWayOptions?.length) {
      return 'All Items are selected';
    }
  };

  return (
    <Modal show={show} className="common-custom-modal bulk-submit-download-modal">
      {spin ? (
        <Loader />
      ) : (
        <>
          <Carousel controls={selectedIds?.length > 1} interval={null} activeIndex={index} onSelect={handleSelectCorousel}>
            {selectedIds.map((prduct, idx) => (
              <Carousel.Item key={`C${idx}`}>
                <Modal.Header className="align-items-center">
                  <Modal.Title id="contained-modal-title-vcenter">
                    <Link style={{ color: 'black' }} className="bulk-title-header" target="_blank" to={`/development-order/${prduct}/design-details/list`}>
                      {' '}
                      {findNameOfProduct(prduct)}
                    </Link>{' '}
                    - {selectedType}({idx + 1}/{selectedIds?.length})
                  </Modal.Title>
                  <span onClick={toggle} className="icon-close cursor-pointer" />
                </Modal.Header>
                <Modal.Body>
                  <div className="container container-bootstrap px-4 px-md-5">
                    <div className="row">
                      <div className="col-md-4">
                        <Select
                          name="Supplier"
                          options={[INTERNAL_SUPPLIER_OPTION, ...(commonSupplierList || [])]}
                          getOptionLabel={({ label }) => `${label}`}
                          getOptionValue={({ label }) => `${label}`}
                          value={getSelectedSupplier()}
                          styles={customStylesWhiteBordered}
                          classNamePrefix="common-select"
                          onChange={(selected) => {
                            handleSelectChange(selected, 'selectedSupplier');
                          }}
                          placeholder={t('COSTING.SUPPLIER')}
                        />
                      </div>
                      <div className="col-md-4">
                        <MultiSelect
                          name="Colourway"
                          options={state?.colourWayOptions || []}
                          value={state?.submitData?.[index]?.selectedColourway || []}
                          labelledBy={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.SELECT_COLOURWAY')}
                          styles={customStylesWhiteBordered}
                          className="bordered-multiselect common-new-multiselect w-100"
                          onChange={(selected) => {
                            handleSelectChange(selected, 'selectedColourway');
                          }}
                          valueRenderer={() => customValueRenderer()}
                        />
                      </div>
                    </div>
                    <div className="full-width-block mt-3 mb-3">
                      <div>
                        <div className="row">
                          {costingAndPurchasing(state, handleSelectAll, checkIsChecked, handleSelect, handleSelectChange, multiselectValues, t)}
                          {technicalPackage(state, handleSelectAll, checkIsChecked, handleSelect, handleSelectChange, multiselectValues, getValue, t)}
                          {otherPackage(state, handleSelectAll, checkIsChecked, handleSelect, handleSelectChange, multiselectValues, t)}
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedType === 'Submit' && (
                    <div className="container px-4 px-md-5">
                      <Accordion className="mb-16 master-accordian min-h-auto">
                        <Card>
                          <Card.Header>
                            <div className="title-container switch-container  d-flex">
                              <div>
                                <div className="switch-common design-switch pl-0">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={index}
                                    checked={submitData[index]?.isSampleRequested}
                                    onClick={(e) => {
                                      handleSelectChange(!submitData[index]?.isSampleRequested, 'isSampleRequested');
                                    }}
                                  />
                                  <label className="design-title m-0" htmlFor={index} />
                                </div>
                              </div>

                              <p>{t('FILTER.REQUEST_SAMPLE')}</p>
                            </div>
                            <div>
                              <OverlayTrigger
                                placement={t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_POPUP_MODAL.AUTO')}
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltipOpenClose}
                              >
                                <CustomTooltip tooltipText={!showRequestSample ? t('COMMON_LABEL.CLOSE') : t('COMMON_LABEL.OPEN')}>
                                  <button
                                    onClick={() => handleSelectChange(!submitData[index]?.showRequestSample, 'showRequestSample')}
                                    type="button"
                                    className="btn-down p-0"
                                  >
                                    {submitData[index]?.showRequestSample ? (
                                      <i className="icon-new-down-arrow-icon icon-dropdown icon-inverse" />
                                    ) : (
                                      <i className="icon-new-down-arrow-icon icon-dropdown" />
                                    )}
                                  </button>
                                </CustomTooltip>
                              </OverlayTrigger>
                            </div>
                          </Card.Header>
                          {submitData[index]?.showRequestSample && submitData[index]?.isSampleRequested && (
                            <Card.Body key={idx}>
                              {sampleModule({ ...state, otherSamplesList }, handleSelectChange, updateGradingGroup, addNewGradingGroup, handleGradingGroupDelete, t, lengthEnabled)}
                            </Card.Body>
                          )}
                        </Card>
                      </Accordion>

                      <Accordion className="mb-16 master-accordian min-h-auto">
                        <Card>
                          <Card.Header>
                            <div className="title-container">
                              <p>{t('FILTER.COMPOSE_EMAIL')}</p>
                            </div>
                            <div>
                              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenCloseEmail}>
                                <CustomTooltip tooltipText={!showComposeEmail ? t('COMMON_LABEL.CLOSE') : t('COMMON_LABEL.OPEN')}>
                                  <button
                                    onClick={() => handleSelectChange(!submitData[index]?.showComposeEmail, 'showComposeEmail')}
                                    className="btn-down"
                                    type="button"
                                  >
                                    {!submitData[index]?.showComposeEmail ? (
                                      <i className="icon-new-down-arrow-icon icon-dropdown" />
                                    ) : (
                                      <i className="icon-new-down-arrow-icon icon-dropdown icon-inverse" />
                                    )}
                                  </button>
                                </CustomTooltip>
                              </OverlayTrigger>
                            </div>
                          </Card.Header>
                          {submitData[index]?.showComposeEmail && <Card.Body className="p-16">{submitEmail(handleSelectChange, getValue, state, t)}</Card.Body>}
                        </Card>
                      </Accordion>
                    </div>
                  )}
                </Modal.Body>
              </Carousel.Item>
            ))}
          </Carousel>
          <div className="common-model-footer">
            <CustomTooltip placement="top" tooltipText={selectedType}>
              <button onClick={handleSubmit} className="btn p-1" type="button" aria-label={selectedType}>
                <span className="icon-Tick-1 f-24" />
              </button>
            </CustomTooltip>
          </div>
        </>
      )}
    </Modal>
  );
}

export default SubmitPopupModal;
